<script lang="ts">
  import { onMount, tick } from "svelte";
  import type { Overlay } from "../overlay";
  import { place, type PlaceAlignModes } from "@lernetz/svelte-common/actions";
  import type { createDropdownMenu } from "../dropdown-menu";
  import { AlignOrigin } from "@lernetz/svelte-common/actions/place";

  export let overlay: Overlay;
  export let menu: ReturnType<typeof createDropdownMenu>;

  export let align: PlaceAlignModes = "Top";

  let node: HTMLElement;

  onMount(async () => {
    await tick();
    place(node, { align, reference: overlay.triggerReference() });
  });
</script>

<div
  bind:this={node}
  use:menu.root
  aria-labelledby={overlay.triggerReference()?.id}
  class="{AlignOrigin[align]} absolute z-dropdown"
  id={$overlay.id}
>
  <slot />
</div>
